import {Checkbox} from 'platform/components';
import {VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {MoneyInputField} from './MoneyInputField';
import {FinancingMoney} from './types/FinancingMoney';
import {getOverrideLabel} from './utils/financingOverrides/getOverrideLabel';

interface FinancingIncludableOverrideProps {
  label: string;
  included: boolean;
  amount: FinancingMoney;
  currency: string;
  isReadOnly: boolean;
  isAmountOverridden: boolean;
  isIncludedOverridden: boolean;
  onIncludedChange: (value: boolean) => void;
  onAmountReset: () => void;
  onAmountChange: (value: FinancingMoney) => void;
}

/** One overridable one-time cost: its amount input plus the "included in offer" toggle. */
export function FinancingIncludableOverride(props: FinancingIncludableOverrideProps) {
  return (
    <VStack spacing={2}>
      <MoneyInputField
        label={getOverrideLabel(props.label, props.isAmountOverridden)}
        value={props.amount}
        currency={props.currency}
        isDisabled={props.isReadOnly}
        resetLabel={i18n.t('entity.vehicleFinancingTemplate.actions.restoreDefault')}
        onReset={props.isAmountOverridden ? props.onAmountReset : undefined}
        onChange={props.onAmountChange}
      />
      <Checkbox
        label={getOverrideLabel(
          i18n.t('page.vehicle.financingAndLeasing.included', {item: props.label}),
          props.isIncludedOverridden
        )}
        helperText={i18n.t('page.vehicle.financingAndLeasing.includedCostHint')}
        value={props.included}
        isDisabled={props.isReadOnly}
        onChange={props.onIncludedChange}
      />
    </VStack>
  );
}
